import { render } from "./PhotoTile.vue?vue&type=template&id=6b0ffcc0&ts=true"
import script from "./PhotoTile.vue?vue&type=script&lang=ts"
export * from "./PhotoTile.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__